import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { error } from 'console';
import { Api } from 'src/app/services/api';
import { SharedModule } from 'src/app/shared/shared-module';
import Swal from 'sweetalert2';


interface alertas {
  vencido:boolean;
  atrasado:boolean;
}
@Component({
  selector: 'app-settings',
  templateUrl: './settings.html',
  styleUrl: './settings.scss',
    imports: [
    CommonModule,SharedModule
  ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Settings implements OnInit{
  usuario:any;
  settings:alertas = {
    vencido: false,
    atrasado: false,
  }
  datos:any;
  toupdate?:any;
  constructor(private apiservice: Api, private cdr: ChangeDetectorRef, public dialogRef: MatDialogRef<Settings>,){}
  ngOnInit(): void {
  this.usuario = localStorage.getItem('userid');
  this.apiservice.getForTable('settings', `user = ${this.usuario}`).subscribe({
    next:(setting:[])=>{
      console.log('settings ', setting);
      if(setting.length == 0){
          this.datos = false;
        return;
      }
     this.datos = true;
     this.toupdate = setting;
      setting.forEach((item:any) =>{
        if(item.nombre == 'vencido'){
            this.settings.vencido = item.valor == '1'? true : false;
        }
       if(item.nombre == 'atrasado'){
            this.settings.atrasado = item.valor == '1'? true : false;
        }
      });
      this.cdr.detectChanges();
      console.log('settings ', this.settings)
  },
error:(err)=>{
  console.log('error jalando settings')
  }});
  }

toggleSetting(key: string, event: Event) {
  const input = event.target as HTMLInputElement;
  this.settings[key] = input.checked;
  console.log(this.settings);
}
savesettings(){
  console.log('datos', this.datos)
if(!this.datos){
  let payload_vencido = {
  nombre: 'vencido',
  valor: this.settings.vencido,
  estatus: this.settings.vencido ? 'Activo' : 'Inactivo',
    user:this.usuario
  }
   let payload_atrasado = {
  nombre: 'atrasado',
  valor: this.settings.atrasado,
  estatus: this.settings.atrasado ? 'Activo' : 'Inactivo',
  user:this.usuario
  }
  this.apiservice.addItem(payload_vencido,'settings').subscribe({
    next:(saved_vencido)=>{
       this.apiservice.addItem(payload_atrasado,'settings').subscribe({
    next:(saved_atrasado)=>{
                  this.showMessageWithAnimation('Configuración guardada', 'success');
                  this.cancel();

    },
    error:(err)=>{
            this.showMessageWithAnimation('Error Guardando tu configuración', 'error');
this.cancel();
      return;
    }
    });
  },
  error:(err)=>{
      this.showMessageWithAnimation('Error Guardando tu configuración', 'error');
    }
  });
}else{
    let vencidoid = this.toupdate.find(item => item.nombre === "vencido")?.id;

    let payload_vencido = {
  nombre: 'vencido',
  valor: this.settings.vencido,
  estatus: this.settings.vencido ? 'Activo' : 'Inactivo',
    user:this.usuario,
    id:vencidoid,
  }
    let atrasado= this.toupdate.find(item => item.nombre === "atrasado")?.id;

   let payload_atrasado = {
  nombre: 'atrasado',
  valor: this.settings.atrasado,
  estatus: this.settings.atrasado ? 'Activo' : 'Inactivo',
  user:this.usuario,
      id:atrasado,
  }

  this.apiservice.updateData('settings',payload_vencido, this.toupdate).subscribe({
    next:(saved_vencido)=>{
       this.apiservice.updateData('settings',payload_atrasado, this.toupdate).subscribe({
    next:(saved_atrasado)=>{
                  this.showMessageWithAnimation('Configuración guardada', 'success');
                  this.cancel();

    },
    error:(err)=>{
            this.showMessageWithAnimation('Error Guardando tu configuración', 'error');
this.cancel();
      return;
    }
    });
  },
  error:(err)=>{
      this.showMessageWithAnimation('Error Guardando tu configuración', 'error');
    }
  });
}
}
     showMessageWithAnimation(text: string, type: 'success' | 'error' | 'warning' | 'info'): void {
       let messageText = text;
       let messageType = type;
       let  showMessage = true;
    Swal.fire({
      // title: "loading...",
      text: messageText,
      icon: messageType,
      showConfirmButton: false,
      timer: 2500,
      timerProgressBar: false,

    });

      }
      cancel(){
        this.dialogRef.close()
      }
}
